import { Component, input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { DatePipe, CommonModule } from '@angular/common';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { TagModule } from 'primeng/tag';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

@Component({
  selector: 'app-detalhe-utilizador',
  imports: [
    DatePipe,
    PaginatorControlComponent,
    TableModule,
    CommonModule,
    DataVoidComponent,
    TagModule,
    MoneyPipe
  ],
  providers: [
    ApoioService,
    CampanhaService,
    MessageService
  ],
  templateUrl: './detalhe-utilizador.component.html',
  styleUrl: './detalhe-utilizador.component.scss'
})
export class DetalheUtilizadorComponent implements OnInit {
  private readonly apoioService = inject(ApoioService);
  private readonly campanhaService = inject(CampanhaService);
  protected readonly messageService = inject(MessageService);
  @Output() onCloseModal = new EventEmitter<boolean>();
  utilizador = input<any>();
  pagamentos: any;
  pagination: Pagination<any> = new Pagination<any>();
  campanhas: any;
  cpm_pagaination: Pagination<any> = new Pagination<any>();

  ngOnInit(): void {
    this.getCampanhasByUserID();
    this.getPagamentosByUserID();
  }

  closeDetalhe() {
    this.onCloseModal.emit(true);
  }

  getPagamentosByUserID() {
    const params = {
      UtilizadorID: this.utilizador()?.id,
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1
    }

    this.apoioService.list(params).subscribe({
      next: (res) => {
        if (res.retorno.codigo === 200) {
          this.pagination = new Pagination().deserialize(res);
          this.pagamentos = res.data;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: `Falha ao processar pagamentos do utilizador ${this.utilizador().userName}`,
          })
        }
      },
      error(err) {
        console.error(err)
      }
    })
  }

  getCampanhasByUserID() {
    const params = {
      UtilizadorID: this.utilizador()?.id,
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1
    }

    this.campanhaService.list(params).subscribe({
      next: (res) => {
        if (res.retorno.codigo === 200) {
          this.cpm_pagaination = new Pagination().deserialize(res);
          this.campanhas = res.data;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: `Falha ao processar campanhas do utilizador ${this.utilizador().userName}`,
          })
        }
      },
      error(err) {
        console.error(err)
      }
    })
  }

  getSeverityPayment(state: string): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | null | undefined {
    switch (state) {
      case 'Pendente':
        return 'secondary';
      case 'Confirmado':
        return 'success';
      case 'Cancelado':
        return 'warn';
      case 'Retornado':
        return 'info';
      default:
        return 'secondary';
    }
  }

  getSeverityCampanha(state: string): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | null | undefined {
    switch (state) {
      case 'Pendente':
        return 'secondary';
      case 'Encerrado':
        return 'success';
      case 'Suspensa':
        return 'danger';
      case 'Recusada':
        return 'warn';
      case 'Em Curso':
        return 'info';
      default:
        return 'warn';
    }
  }

  onPageCPM(event: any) {
    this.cpm_pagaination.pageNumber = event.page + 1;
    this.cpm_pagaination.pageSize = event.rows;
    this.getCampanhasByUserID();
  }

  onPagePayment(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getPagamentosByUserID();
  }
}